export default "__VITE_ASSET__BZp7kr3H__"